/**
 * 这里是精简版本的 is
 * @module os
 * @file Created on Mon Nov 26 2018
 * @author wangyongqing <wangyongqing01@baidu.com>
 */
import UA from './ua';
/**
 * 是否是安卓
 * @function isAndroid
 * @param {string} ua - ua 默认是 userAgent
 */
export function isAndroid(ua = UA) {
    return /(Android);?[\s/]+([\d.]+)?/.test(ua);
}
/**
 * 是否是ios
 * @function isIOS
 * @param {string} ua - ua 默认是 userAgent
 */
export function isIOS(ua = UA) {
    return /(iPhone|iPod|iPad)/.test(ua);
}

/**
 * 获取系统名称
 * @function getOSName
 * @return {string} ios/android/unknown
 */
export function getOSName(ua = UA) {
    return isIOS(ua) ? 'ios' : isAndroid(ua) ? 'android' : 'unknown';
}

/**
 * getOsVersion 获取系统版本
 * @function getOSVersion
 * @param {string} ua - ua 默认是浏览器 ua
 */
export function getOSVersion(ua = UA) {
    const android = ua.match(/(Android);?\s+([\d.]+)?/);
    if (android) {
        return android[2];
    }
    const iphone = ua.match(/(iPhone\sOS)\s([\d_]+)/);
    if (iphone) {
        return iphone[2].replace(/_/g, '.');
    }
    return 0;
}
